module.exports = __webpack_public_path__ + "static/media/haiwaiyuebaomuban.b321b957.png";